module.exports = __webpack_public_path__ + "img/bv.0b74d901.svg";